enum APP_PAGE {
  MY_SDS = 'my-sds',
  GLOBAL_SEARCH_SDS = 'global-search-sds',
}

export default APP_PAGE;
